import {
  Box,
  Button,
  Checkbox,
  Fieldset,
  Flex,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useState } from "react";
import { formatDateTime } from "../../../../../common/FormatDate/FormatDate";
import { modals } from "@mantine/modals";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
type Props = {
  id: number;
  type: string;
  onhandlePrint: (id: string | number, type: string | null) => void;
  setValuePrintHandoverModal: any;
};
type FormInput = {
  soHopDong: string | null;
  kyNgay: string | null;
  maDonDatHang: string | null;
  ngayBanGiao: string | null;
  daiDienBenBan: string | null;
  chucVuBenBan: string | null;
  chucVuBenMua: string | null;
  hienThi1: string | null;
  hienThi2: string | null;
};
const OptionPrintHandover = ({
  id,
  type,
  onhandlePrint,
  setValuePrintHandoverModal,
}: Props) => {
  const [optionHidden, setOptionHidden] = useState({
    isHopDong: true,
    isDonDatHang: true,
    isBenMua: true,
  });

  const form = useForm<FormInput>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      soHopDong: null,
      kyNgay: null,
      maDonDatHang: null,
      ngayBanGiao: null,
      daiDienBenBan: null,
      chucVuBenBan: null,
      chucVuBenMua: null,
      hienThi1: "Serial",
      hienThi2: "CoGia",
    },
    validate: {
      soHopDong: (value: string | null) => {
        if (optionHidden.isHopDong && !value) {
          return "Số hợp đồng không được để trống";
        }
      },
      kyNgay: (value: string | null) => {
        if (optionHidden.isHopDong && !value) {
          return "Ký ngày không được để trống";
        }
      },
      // maDonDatHang: (value: string | null) => {
      //   if (optionHidden.isDonDatHang && !value) {
      //     return "Mã đơn đặt hàng không được để trống";
      //   }
      // },
      ngayBanGiao: (value: string | null) => {
        if (!value) {
          return "Ngày bàn giao không được để trống";
        }
      },
      daiDienBenBan: (value: string | null) => {
        if (!value) {
          return "Đại diện bên bán không được để trống";
        }
      },
      chucVuBenBan: (value: string | null) => {
        if (!value) {
          return "Chức vụ bên bán không được để trống";
        }
      },
      chucVuBenMua: (value: string | null) => {
        if (optionHidden.isBenMua && !value) {
          return "Chức vụ bên mua không được để trống";
        }
      },
    },
  });
  const handleCreatePrint = async (data: any) => {
    if (form.getValues().hienThi1 === "" || form.getValues().hienThi2 === "") {
      NotificationExtension.Fails(
        "Vui lòng chọn đầy đủ lựa chọn hiển thị 1 và 2 của phiếu in"
      );
    } else {
      setValuePrintHandoverModal({
        ...data,
        maDonDatHang:
          data?.maDonDatHang && optionHidden?.isDonDatHang
            ? data?.maDonDatHang
            : null,
        soHopDong:
          data?.soHopDong && optionHidden?.isHopDong ? data?.soHopDong : null,
        chucVuBenMua:
          data?.chucVuBenMua && optionHidden?.isBenMua
            ? data?.chucVuBenMua
            : null,
        kyNgay:
          data?.kyNgay && optionHidden?.isHopDong
            ? formatDateTime(data?.kyNgay)
            : null,
        ngayBanGiao: formatDateTime(data?.ngayBanGiao) ?? null,
      });
      modals.closeAll();
      setTimeout(() => {
        onhandlePrint(id, type);
      }, 1000);
    }
  };
  return (
    <div>
      <form onSubmit={form.onSubmit((values) => handleCreatePrint(values))}>
        <Box
          style={{
            margin: "7px 3px",
          }}
        >
          <Box>
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Hợp đồng</Text>
              </div>
              <div>
                <Select
                  w={"100px"}
                  defaultValue={"Co"}
                  data={[
                    { value: "Co", label: "Có" },
                    { value: "Khong", label: "Không" },
                  ]}
                  onChange={(e) => {
                    setOptionHidden((prev) => {
                      return {
                        ...prev,
                        isHopDong: e === "Co" ? true : false,
                      };
                    });
                  }}
                  allowDeselect={false}
                />
              </div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
                display: optionHidden.isHopDong ? "block" : "none",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Số hợp đồng</Text>
                </div>
                <div style={{ paddingTop: "4px" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập số hợp đồng"
                    key={form.key("soHopDong")}
                    {...form.getInputProps("soHopDong")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Ký ngày</Text>
                </div>
                <div style={{ paddingTop: "4px" }}>
                  <DatePickerInput
                    w={"250px"}
                    size="sm"
                    placeholder="Chọn ngày ký"
                    // locale="vi"
                    key={form.key("kyNgay")}
                    {...form.getInputProps("kyNgay")}
                    valueFormat="DD/MM/YYYY"
                    // onChange={(date: any) => {
                    //   console.log("date", date);
                    //   form.setFieldValue("kyNgay", String(date ?? ""));
                    // }}
                    clearable
                  />
                </div>
              </Flex>
            </Box>
          </Box>
          <Box
            style={{
              marginTop: "7px",
            }}
          >
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Đơn đặt hàng</Text>
              </div>
              <div>
                <Select
                  w={"100px"}
                  defaultValue={"Co"}
                  data={[
                    { value: "Co", label: "Có" },
                    { value: "Khong", label: "Không" },
                  ]}
                  onChange={(e) => {
                    setOptionHidden((prev) => {
                      return {
                        ...prev,
                        isDonDatHang: e === "Co" ? true : false,
                      };
                    });
                  }}
                  allowDeselect={false}
                />
              </div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
                display: optionHidden.isDonDatHang ? "block" : "none",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Mã đơn đặt hàng</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập mã đơn đặt hàng"
                    key={form.key("maDonDatHang")}
                    {...form.getInputProps("maDonDatHang")}
                  />
                </div>
              </Flex>
            </Box>
          </Box>
          <Box
            style={{
              marginTop: "7px",
            }}
          >
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Ngày bàn giao, nghiệm thu</Text>
              </div>
              <div style={{ padding: "4px 0" }}>
                <DatePickerInput
                  w={"250px"}
                  size="sm"
                  placeholder="Chọn ngày bàn giao, nghiệm thu"
                  locale="vi"
                  key={form.key("ngayBanGiao")}
                  {...form.getInputProps("ngayBanGiao")}
                  valueFormat="DD/MM/YYYY"
                  // onChange={(date) => {
                  //   form.setFieldValue(
                  //     "ngayBanGiao",
                  //     formatDateNotTimeZone(date) ?? ""
                  //   );
                  // }}
                  clearable
                />
              </div>
            </Flex>
          </Box>
          <Box style={{ marginTop: "7px" }}>
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Bên bán</Text>
              </div>
              <div></div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập người đại diện"
                    key={form.key("daiDienBenBan")}
                    {...form.getInputProps("daiDienBenBan")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập chức vụ"
                    key={form.key("chucVuBenBan")}
                    {...form.getInputProps("chucVuBenBan")}
                  />
                </div>
              </Flex>
            </Box>
          </Box>
          <Box style={{ marginTop: "7px" }}>
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Bên mua</Text>
              </div>
              <div
                style={{
                  padding: "4px 0",
                }}
              >
                <Select
                  w={"100px"}
                  defaultValue={"Co"}
                  data={[
                    { value: "Co", label: "Có" },
                    { value: "Khong", label: "Không" },
                  ]}
                  onChange={(e) => {
                    setOptionHidden((prev) => {
                      return {
                        ...prev,
                        isBenMua: e === "Co" ? true : false,
                      };
                    });
                  }}
                  allowDeselect={false}
                />
              </div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
                display: optionHidden.isBenMua ? "block" : "none",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập chức vụ"
                    key={form.key("chucVuBenMua")}
                    {...form.getInputProps("chucVuBenMua")}
                  />
                </div>
              </Flex>
            </Box>
            <Flex
              direction={"row"}
              align={"center"}
              gap={"sm"}
              w={"100%"}
              justify={"space-around"}
            >
              <Fieldset
                legend="Lựa chọn hiển thị 1"
                style={{
                  width: "40%",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                }}
              >
                <Flex
                  direction={"column"}
                  gap={"lg"}
                  align={"left"}
                  justify={"left"}
                >
                  <Checkbox
                    checked={form.getValues().hienThi1 === "Serial"}
                    value="Serial"
                    label="Serial"
                    onChange={() =>
                      form.setFieldValue(
                        "hienThi1",
                        form.getValues().hienThi1 === "Serial" ? "" : "Serial"
                      )
                    }
                  />
                  <Checkbox
                    checked={form.getValues().hienThi1 === "Sl"}
                    value="Sl"
                    label="Số lượng"
                    onChange={() =>
                      form.setFieldValue(
                        "hienThi1",
                        form.getValues().hienThi1 === "Sl" ? "" : "Sl"
                      )
                    }
                  />
                </Flex>
              </Fieldset>
              <Fieldset
                legend="Lựa chọn hiển thị 2"
                style={{
                  width: "40%",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                }}
              >
                <Flex
                  direction={"column"}
                  gap={"lg"}
                  align={"left"}
                  justify={"left"}
                >
                  <Checkbox
                    checked={form.getValues().hienThi2 === "CoGia"}
                    value="coGia"
                    label="Có giá"
                    onChange={() =>
                      form.setFieldValue(
                        "hienThi2",
                        form.getValues().hienThi2 === "CoGia" ? "" : "CoGia"
                      )
                    }
                  />
                  <Checkbox
                    checked={form.getValues().hienThi2 === "khongGia"}
                    value="khongGia"
                    label="Không giá"
                    onChange={() =>
                      form.setFieldValue(
                        "hienThi2",
                        form.getValues().hienThi2 === "khongGia"
                          ? ""
                          : "khongGia"
                      )
                    }
                  />
                </Flex>
              </Fieldset>
            </Flex>
          </Box>
        </Box>
        <div style={{ textAlign: "center", marginTop: "6px" }}>
          <Button type="submit" variant="light">
            In phiếu
          </Button>
        </div>
      </form>
    </div>
  );
};

export default OptionPrintHandover;
